import {
  Companion_instance20vpendjsus8n as Companion_instance,
  TimeInZone1aol3tfiawf3k as TimeInZone,
} from './shared.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { TimeZone3oibfp0mqo4lg as TimeZone } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareTimeInZoneFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [TimeInZone_time_getInstance(), TimeInZone_zone_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function TimeInZone_time$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function TimeInZone_time$_get_name_$ref_vpd54r() {
  return (p0) => p0.i20();
}
function TimeInZone_time$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function TimeInZone_time$_get_serializer_$ref_yix0yq() {
  return (p0) => p0.h2j();
}
function TimeInZone_time$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function TimeInZone_time$_get_annotations_$ref_kxg2sa() {
  return (p0) => p0.bz();
}
var TimeInZone_timeClass;
function TimeInZone_time() {
  if (TimeInZone_timeClass === VOID) {
    class $ {
      constructor() {
        TimeInZone_time_instance = this;
        var tmp = this;
        tmp.c8p_1 = lazy(TimeInZone_time$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d8p_1 = lazy(TimeInZone_time$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e8p_1 = lazy(TimeInZone_time$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, TimeInZone_time$_get_name_$ref_vpd54r(), null);
        return tmp0.f2();
      }
      f8p(receiver) {
        return receiver.g8p_1;
      }
      k2j(receiver) {
        return this.f8p(receiver instanceof TimeInZone() ? receiver : THROW_CCE());
      }
      i8p(receiver, value) {
        return receiver.j8p(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof TimeInZone() ? receiver : THROW_CCE();
        return this.i8p(tmp, value instanceof LocalTime() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, TimeInZone_time$_get_serializer_$ref_yix0yq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, TimeInZone_time$_get_annotations_$ref_kxg2sa(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'TimeInZone_time', VOID, VOID, [SerializableProperty()]);
    TimeInZone_timeClass = $;
  }
  return TimeInZone_timeClass;
}
var TimeInZone_time_instance;
function TimeInZone_time_getInstance() {
  if (TimeInZone_time_instance === VOID)
    new (TimeInZone_time())();
  return TimeInZone_time_instance;
}
function TimeInZone_zone$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(1);
}
function TimeInZone_zone$_get_name_$ref_l191ja() {
  return (p0) => p0.i20();
}
function TimeInZone_zone$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function TimeInZone_zone$_get_serializer_$ref_dm56zl() {
  return (p0) => p0.h2j();
}
function TimeInZone_zone$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(1);
}
function TimeInZone_zone$_get_annotations_$ref_bzhraz() {
  return (p0) => p0.bz();
}
var TimeInZone_zoneClass;
function TimeInZone_zone() {
  if (TimeInZone_zoneClass === VOID) {
    class $ {
      constructor() {
        TimeInZone_zone_instance = this;
        var tmp = this;
        tmp.k8p_1 = lazy(TimeInZone_zone$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l8p_1 = lazy(TimeInZone_zone$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m8p_1 = lazy(TimeInZone_zone$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.k8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, TimeInZone_zone$_get_name_$ref_l191ja(), null);
        return tmp0.f2();
      }
      f8p(receiver) {
        return receiver.h8p_1;
      }
      k2j(receiver) {
        return this.f8p(receiver instanceof TimeInZone() ? receiver : THROW_CCE());
      }
      n8p(receiver, value) {
        return receiver.j8p(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof TimeInZone() ? receiver : THROW_CCE();
        return this.n8p(tmp, value instanceof TimeZone() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, TimeInZone_zone$_get_serializer_$ref_dm56zl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, TimeInZone_zone$_get_annotations_$ref_bzhraz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'TimeInZone_zone', VOID, VOID, [SerializableProperty()]);
    TimeInZone_zoneClass = $;
  }
  return TimeInZone_zoneClass;
}
var TimeInZone_zone_instance;
function TimeInZone_zone_getInstance() {
  if (TimeInZone_zone_instance === VOID)
    new (TimeInZone_zone())();
  return TimeInZone_zone_instance;
}
//region block: exports
export {
  prepareTimeInZoneFields as prepareTimeInZoneFields3he4wzvtrtx34,
};
//endregion

//# sourceMappingURL=TimeInZoneFields.mjs.map
